module.exports = __webpack_public_path__ + "static/media/app design (3).93423494.png";